//
// GeneratedColumn.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./ColumnBase";
import "./GeneratedDataType";

var GeneratedColumn = createModule("BIRD::GeneratedColumn", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::ColumnBase"], EventDispatcher, [
    ,
    {
        dataType: 4,
        name: 7,
        stringLength: 4,
        forceServerFormatting: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default GeneratedColumn;
